<template>
    <div>
        <div>
            <form-select id="deviceModel" type="text" label="Model" :error="msg.modelId" v-model.trim="localCopy.modelId" :options="models"/>
            <form-input id="serial" type="text" label="Serial No" :error="msg.serial" v-model.trim="localCopy.serial"/>

            <h4 class="text-md font-medium pt-6">Purchase Information</h4>
            <form-select id="company" type="text" label="Company" :error="msg.companyId" v-model.trim="localCopy.companyId" :options="companies"/>
            <form-input id="date" type="text" label="Date" :error="msg.date" readonly="true" :modelValue="momentDate(localCopy.date)"/>
            <form-input id="application" type="text" label="Application" :error="msg.application" v-model.trim="localCopy.application"/>

            <div v-if="creating" class="flex gap-2 pt-8">
                <custom-button class="flex-grow" type="primary" @click="create">Create</custom-button>
            </div>

        </div>
    </div>
</template>

<script>
import FormInput from '../../components/FormInput.vue'
import FormSelect from '../../components/FormSelect.vue'
import CustomButton from '../../components/CustomButton.vue'
import _ from 'lodash';
export default {
  components: { FormInput, FormSelect, CustomButton },
  props: [ 'dataId', 'path', 'creating' ],
  data: function() {
      return {
          changed: false,
          setPassword: false,
          models: [],
          companies: [],
          backingData: {},
          localCopy: {},
          msg: {}
      }
  },
  mounted: async function() {
        let query = await this.axios.get(`/deviceModel/all`)
        this.models = query.data
        query = await this.axios.get(`/company/all`)
        this.companies = query.data

      await this.updateData()
  },
  methods: {
      updateData: async function() {
        let query = await this.axios.get(this.path + `/${this.dataId}`) 
        this.backingData = query.data
        this.localCopy = Object.assign(Object.create(Object.getPrototypeOf(this.backingData)), this.backingData)
        this.changed = false
      },
      close: function(navToId) {
        this.$emit('close', navToId)
      },
      validate: function() {
        this.msg = {}

        var constraints = {
            modelId: {
                presence: true,
            },
            serial: {
                presence: true,
                format: {
                    pattern: '[A-Za-z0-9]{22}',
                    message: '^Serial number must be 22 letters or numbers'
                }
            },
            companyId: {
                presence: true
            }
        };

        this.msg = this.$validate(this.localCopy, constraints) || {}
        if (this.creating) {
            if (!this.msg.password && this.localCopy.password != this.localCopy.password2) { this.msg.password2 = 'Passwords must match' }
        }

        return Object.keys(this.msg).length == 0
      },
      create: async function() {
          if (this.validate()) {
              try {
                  let id = await this.axios.post(this.path + '/create', this.localCopy)
                  this.$emit('detailUpdated', {
                      serial: this.serial,
                      modelId: this.modelId,
                      companyId: this.companyId
                  })
                  this.close(id.data)
              }
              catch (error) {
                  if (error && error.response && error.response.data && error.response.data.msg) {
                      this.msg = error.response.data.msg
                  }
              }
          }
      },
      closeResetPassword: function() {
          this.setPassword = false;
          this.localCopy.password = ''
          this.localCopy.password2 = ''
      },
      resetPassword: async function() {
        var constraints = {
            password: {
                presence: true,
                length: { is: 4 },
                numericality: { onlyInteger: true, notGreaterThan: 9999, notLessThan: 0 }
            }
        };
        this.msg = this.$validate(this.localCopy, constraints) || {}
        if (!this.msg.password && this.localCopy.password != this.localCopy.password2) { this.msg.password2 = 'Passwords must match' }

        if (Object.keys(this.msg).length == 0) {
            await this.axios.post(this.path + '/setpassword', {
                id: this.localCopy.id,
                password: this.localCopy.password
            })

            this.changed = false
            this.closeResetPassword()
        }
      },
      verifyUser: async function() {
        await this.axios.post(this.path + '/verify', {
            id: this.localCopy.id
        })
        await this.updateData()
      }
  },
  updated: function() {
      if (!this.creating) {
        const newVal = !_.isEqual(this.localCopy, this.backingData)
        if (this.changed != newVal) {
            this.changed = newVal;
            this.$emit('detailDirty', newVal)
        }
      }
  }
}
</script>